module.exports = __webpack_public_path__ + "static/media/des-how-it-looks.a57e8633.png";